import React from "react";
import { useTranslation } from "react-i18next";
import { BasketSurveyItem, questionId, getSurveySectionsInDisplayOrder } from "../../../models/Survey";
import SurveyQuestion from "./SurveyQuestion";
import { MdConfirmationNumber } from "react-icons/md";

interface IProps {
  item: BasketSurveyItem;
  answers: Record<string, string>;
  onAnswer: (questionId: string, value: string) => void;
  invalidQuestionIds: Set<string>;
}

const SurveyForm: React.FC<IProps> = ({ item, answers, onAnswer, invalidQuestionIds }) => {
  const { t } = useTranslation();

  return (
    <div className="survey-form">
      <div className="survey-form__ticket">
        <div className="survey-form__ticket-accent" />
        <div className="survey-form__ticket-body">
          <div className="survey-form__ticket-icon">
            <MdConfirmationNumber size={20} />
          </div>
          <div className="survey-form__ticket-info">
            <h5 className="survey-form__assort-name">{item.assortName}</h5>
            <div className="survey-form__assort-meta">
              {item.validFrom && (
                <p className="caption text-color-light-gray">
                  {t("data_rozpoczecia")}: {item.validFrom}
                </p>
              )}
              {item.price > 0 && (
                <p className="caption text-color-light-gray">
                  {t("cena")}: {item.price} {t("zl")}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      {getSurveySectionsInDisplayOrder(item.survey).map((section) => (
        <div key={questionId(section)} className="survey-form__section">
          {section.title && (
            <p className="survey-form__section-title body-text-large text-bold">{section.title}</p>
          )}
          {section.description && (
            <p className="survey-form__section-description text-color-light-gray">{section.description}</p>
          )}
          <div className="survey-form__questions">
            {section.questions.map((q) => {
              const qid = questionId(q);
              return (
                <div key={qid} className="survey-form__question" data-survey-question-id={qid}>
                  <SurveyQuestion
                    question={q}
                    value={answers[qid] ?? ""}
                    onChange={onAnswer}
                    hasError={invalidQuestionIds.has(qid)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SurveyForm;
